import ConfluenceSlackService from './ConfluenceSlackService';
import JiraSlackService from './JiraSlackService';
import PlatformSlackService from './PlatformSlackService';
export function slackServiceFactory(cloudId, product, createAnalyticsEvent) {
  switch (product) {
    case 'platform':
      return new PlatformSlackService(cloudId, createAnalyticsEvent);
    case 'confluence':
      return new ConfluenceSlackService(cloudId, createAnalyticsEvent);
    default:
      return new JiraSlackService(cloudId, createAnalyticsEvent);
  }
}